import { render, staticRenderFns } from "./SocialMediaIcons.vue?vue&type=template&id=a89f6fb4&scoped=true&"
import script from "./SocialMediaIcons.vue?vue&type=script&lang=js&"
export * from "./SocialMediaIcons.vue?vue&type=script&lang=js&"
import style0 from "./SocialMediaIcons.vue?vue&type=style&index=0&id=a89f6fb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a89f6fb4",
  null
  
)

export default component.exports